import React, { useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataModalEditMobileWarning } from '../../../../redux/actions/partials/modals/modalEditMobileWarning';
import { handleChangeDataModalEditMobileVerifyOne } from '../../../../redux/actions/partials/modals/modalEditMobileVerifyOne';
import { USERS_EDIT_MOBILE_SEND_OTP_1_POST } from '../../../../apis';
import apiRequest from '../../../../utils/apiRequest';
import useOutsideClick from './hooks/useOutsideClick'; 


const ModalEditMobileWarning = (props) => {

	const dispatch = useDispatch();

	const { isMobile } = useSelector(state => state.general);
	const { isActive} = useSelector(state => state.modalEditMobileWarning);
	const { newMobile} = useSelector(state => state.modalEditMobileVerifyOne);
	const { token } = useSelector(state => state.login);


	const handleClose = () => {
		dispatch(handleChangeDataModalEditMobileWarning('isActive', false))
		setTimeout(() => {
            dispatch(handleChangeDataModalEditMobileWarning('isOpen', false));
        }, 250);
    };


    const outerRef = useRef(null);
  	const centerBoxRef = useRef(null);
  	useOutsideClick(outerRef, centerBoxRef, handleClose, [ModalEditMobileWarning]);


    const handleSendCode = () => {
    	apiRequest({
		    dispatch,
		    endpoint: USERS_EDIT_MOBILE_SEND_OTP_1_POST,
		    method: 'post',
		    data: { mobile: newMobile },
		    token: token,
		    onSuccess: (res) => {
		      	dispatch(handleChangeDataModalEditMobileVerifyOne('mobile', res.mobile));
            	dispatch(handleChangeDataModalEditMobileVerifyOne('timerTime', parseInt(res.timer_time)));
            	dispatch(handleChangeDataModalEditMobileVerifyOne('isOpen', true));
            	setTimeout(() => dispatch(handleChangeDataModalEditMobileVerifyOne('isActive', true)), 250);

                handleClose();
		    },
	  	});
    }
    



    return (

		<div ref={outerRef} className={`ReactModal__Overlay ${isActive ? 'ReactModal__Overlay--after-open' : ''}`} style={{position: 'fixed', inset: '0px', backgroundColor: 'rgba(0, 0, 0, 0.3)', zIndex: '11'}}>
			<div ref={centerBoxRef} className="ReactModal__Content ReactModal__Content--after-open bg-neutral-000 absolute overflow-y-hidden rounded-medium styles_Modal__TsaRp" tabIndex="-1" role="dialog" aria-modal="true" style={ !isMobile ? {width: '460px'} : {width: '100%', maxHeight: '100vh', height: '100%'} }>
				<div className="flex flex-col h-full overflow-y-hidden styles_ModalLayout__y3Bs1" style={{paddingTop: '59px'}}>
					<div className="w-full z-1 bg-neutral-000 fixed top-0 right-0 px-5" width="420" height="58.59375">
						<div className="flex items-center border-complete-b-200">
							<div className="break-words py-3 grow">
								<div className="flex items-center grow">
									<p className="grow text-h5 text-neutral-900">
										<span className="relative">ویرایش شماره موبایل
										</span>
									</p>
								</div>
							</div>
							<div className="grow text-h5">
							</div>
							<div className="flex cursor-pointer" onClick={handleClose}>
								<svg data-test-id="close-modal-icon-button" style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
									<use xlinkHref="#close"></use>
								</svg>
							</div>
						</div>
					</div>
					<div className="grow flex flex-col overflow-y-auto">
						<div className="grow flex flex-col styles_children__hHq5Q py-4 px-5">
							<div>
								<p className="text-body-1 text-neutral-900 mb-4">برای تغییر به شماره جدید، باید شماره فعلی را دوباره تایید کنید.
								</p>
								<div className="flex flex-row lg:justify-end gap-3">
									<button onClick={handleClose} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--outlined__saFC3 styles_btn--primary__y0GEv rounded-medium">
										<div className="flex items-center justify-center relative grow">انصراف
										</div>
									</button>
									<button onClick={handleSendCode} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--primary__y0GEv rounded-medium">
										<div className="flex items-center justify-center relative grow">دریافت کد تایید
										</div>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>



        
    );
}

export default ModalEditMobileWarning;
